<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-layout row>
      <v-flex class="xs12 sm12 lg12">
        <div class="body-2 font-weight-bold nav nav-tabs">
          <!-- /.tabrow -->
          <li>
            <a >Summary <span class="yellow--text">
              <help-link help_id="12" style="float: right"/>
              <br>
              {{
                (
                    !$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress && (current_report_to_run !== '1P1C')) ?
                    'Note-Totals in summary might differ from totals in REO map due to filter selections' :
                    ''
              }}
            </span>

            </a>
          </li>
        </div>
      </v-flex>
    </v-layout>

    <!--    <v-container class="ma-0 pa-0 mt-1 body-2  black&#45;&#45;text" fluid>-->
    <div class="tab-content">
      <div class="tab-pane active white">
        <v-container class="ma-0 pa-0 pt-1 pb-1" fluid>
          <v-layout
              class="justify-space-between no-gutters text-md-center black--text mb-1"
              row
          >
            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-flex class="ma-0 pa-0 sm2 ml-4 text-start" v-on="on">
                  <v-icon class="black--text">mdi-earth</v-icon>
                  <v-progress-circular
                      v-if="MarketProductCombinationsUpdating"
                      :size="20"
                      :width="3"
                      color="green"
                      indeterminate
                  ></v-progress-circular>
                  <span
                      v-if="!MarketProductCombinationsUpdating"
                      class="ma-0 pa-0"
                      :class="{'red--text': markets_exceed && market_calc_count() !== 0}"
                  >
                    {{ market_calc_count() }}
                    <span
                        v-if="markets_exceed && market_calc_count() !== 0"
                        class="caption"
                    ><br/>(max
                      {{ $store.state.user.userServerInfo.app_config.max_markets }})</span
                    >
                  </span>
                </v-flex>
              </template>
              <span>Markets count</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-flex class="ma-0 pa-0 sm2" v-on="on">
                  <v-icon class="black--text">mdi-dolly</v-icon>

                  <v-progress-circular
                      v-if="MarketProductCombinationsUpdating"
                      :size="20"
                      :width="3"
                      color="green"
                      indeterminate
                  ></v-progress-circular>
                  <span
                      v-if="!MarketProductCombinationsUpdating"
                      class="ma-0 pa-0"
                      :class="{'red--text': products_exceed && product_calc_count() !== 0}"
                  >
                    {{ product_calc_count() }}
                    <span
                        v-if="products_exceed && product_calc_count() !== 0"
                        class="caption ml-6"
                    ><br/>(max
                      {{
                        $store.state.user.userServerInfo.app_config.max_products
                      }})</span
                    >
                  </span>
                </v-flex>
              </template>
              <span>Products count</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-flex class="ma-0 pa-0 sm3" v-on="on">
                  <v-icon class="black--text">mdi-sigma</v-icon>

                  <v-progress-circular
                      v-if="MarketProductCombinationsUpdating"
                      :size="20"
                      :width="3"
                      color="green"
                      indeterminate
                  ></v-progress-circular>
                  <span
                      v-if="!MarketProductCombinationsUpdating"
                      class="ma-0 pa-0"
                      :class="{'red--text': combinations_exceed}"
                  >
                    {{
                      vFmt(
                          $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                              .combinations.combinations,
                          0,
                      ) || 0
                    }}
                    <span v-if="combinations_exceed" class="caption ml-4"
                    ><br/>(max
                      {{
                        $store.state.user.userServerInfo.app_config.max_dsm_results
                      }})</span
                    >
                  </span>
                </v-flex>
              </template>
              <span>Number of combinations</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-flex class="ma-0 text-start" v-on="on">
                  <v-icon class="black--text">mdi-cash</v-icon>
                  <v-progress-circular
                      v-if="MarketProductCombinationsUpdating"
                      :size="20"
                      :width="3"
                      color="green"
                      indeterminate
                  ></v-progress-circular>
                  <span v-if="!MarketProductCombinationsUpdating" class="ma-0 pa-0">
                    {{
                      totalValueString(
                          $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                              .combinations.trade_value,
                      )
                    }}
                  </span>
                </v-flex>
              </template>
              <span>Untapped potential</span>
            </v-tooltip>
          </v-layout>
        </v-container>
      </div>
    </div>

    <v-layout
        v-if="
        $store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
          .markets_count === 0 &&
        $store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
          .products_count === 0 &&
        $store.state.tradeDSM.dsm_filter_setttings.list_manager_selections_country
          .length > 0 &&
        $store.state.tradeDSM.dsm_filter_setttings.list_manager_selections_product
          .length === 0
      "
        class="justify-space-between no-gutters"
        row
    >
      <h2 class="outline pa-2 mt-3 tab-blue lighten-3 text-center">
        Unfortunately this country does not have representative data for all elements of
        the TRADE-DSM methodology – therefore could not be modelled. Please select a
        different country to analyse.
      </h2>
    </v-layout>
  </div>
</template>
<script>
import vFmt from '@/components/application-level/mixins/vFmt';
import {mapGetters} from 'vuex';
import helpLink from "@/components/application-level/help-system/help-link";

export default {
  name: 'top-summary-results',
  components: {helpLink},
  mixins: [vFmt],

  computed: {
    ...mapGetters([
      'app_data',
      'selectionCounts',
      'MarketProductCombinationsUpdating',
      'is_run_cube_valid',
    ]),
    markets_exceed() {
      return (
          (this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                  .report_type_to_generate ===
              '1PMC') &
          !this.is_run_cube_valid
      );
    },
    products_exceed() {
      return (
          (this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                  .report_type_to_generate ===
              'MP1C') &
          !this.is_run_cube_valid
      );
    },
    combinations_exceed() {
      return (
          (this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                  .report_type_to_generate ===
              'MPMC') &
          !this.is_run_cube_valid
      );
    },

    productAndCountrySelected() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings['Destination_Market'].length >
          0 &&
          this.$store.state.tradeDSM.dsm_filter_setttings['HS6_Code'].length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    markets() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0] &&
          this.productAndCountrySelected
      ) {
        return this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult.length;
      } else {
        return '';
      }
    },
    products() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0] &&
          this.productAndCountrySelected
      ) {
        return this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult.length;
      } else {
        return '';
      }
    },
    combinations() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0] &&
          this.productAndCountrySelected
      ) {
        return this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult.length;
      } else {
        return '';
      }
    },
    untappedPotential() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0] &&
          this.productAndCountrySelected
      ) {
        return Math.round(
            this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0][
                'Avg6Major'
                ] * 1000,
        );
      } else {
        return '';
      }
    },
  },
  methods: {
    product_calc_count() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
              .products_count > 0
      ) {
        return this.vFmt(
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                .products_count,
            0,
        );
      } else {
        if (
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                .products.HS6_Code.length === 1
        ) {
          return 1;
        } else return 0;
      }
    },
    market_calc_count() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
              .markets_count > 0
      ) {
        return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
            .markets_count;
      } else {
        if (
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                .markets.C_Code.length === 1
        ) {
          return 1;
        } else return 0;
      }
    },
  },
};
</script>
<style scoped>
.v-icon {
  color: white;
}

.disabled {
  pointer-events: none;
}
</style>
